import React, { useEffect } from "react";
import { useTheme } from "../../../contexts/ThemeContext";
import { readableColor } from "polished";

export const ProgressTable = ({ children, headers }) => {
  const theme = useTheme();
  const [contrastColor, setContrastColor] = React.useState("#fff");

  useEffect(() => {
    if (theme) {
      setContrastColor(readableColor(theme.colors.backgroundColorMain));
    }
  }, [theme]);

  return (
    <div className="relative flex flex-col w-full h-full overflow-auto shadow-xl rounded-lg bg-clip-border"
      style={{
        backgroundColor: theme.mode === "dark" ? theme.colors?.backgroundColorNotCurrentModule : theme.colors?.background_secondary?.backgroundColor,
        boxShadow: theme.styles?.box_temas?.backgroundColor,
      }}
    >
      <table className="w-full text-left table-auto min-w-max">
        <thead>
          <tr>
            {headers &&
              headers.map((h, idx) => {
                return (
                  <th
                    className="p-4 border-b"
                    style={{
                      backgroundColor: theme.colors.backgroundColorMain,
                      borderColor: theme.colors.backgroundColorNotCurrentModule,
                    }}
                    key={idx}
                    scope="col"
                  >
                    <p
                      className="block text-md leading-none font-bold uppercase"
                      style={{
                        color: contrastColor,
                      }}
                    >
                      {h}
                    </p>
                  </th>
                );
              })}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
};
